import "./WaitTimesModal.scss"
import {IonCol, IonIcon, IonImg, IonModal, IonRow} from "@ionic/react";
import React, {FC, ReactNode, useMemo, useState} from "react";
import {useWaitTimes} from "../../helpers/waitTimesHelper";
import Button from "../Button";
import {baseUrl} from "../../helpers/configHelper";

interface IWaitTimesCheckoutModal {
    onDidDismiss: () => void;
    onDidAccept: () => void;
    showing: boolean;
}

export const WaitTimesCheckoutModal: FC<IWaitTimesCheckoutModal> = ({showing, onDidDismiss, onDidAccept}) => {
    const {
        waitingRange,
        waitingLabel,
    } = useWaitTimes();

    return <IonModal swipeToClose={true} isOpen={showing} onDidDismiss={onDidDismiss} cssClass="waiting-modal waiting-modal-checkout">
        <IonRow className="waiting-container">
            <IonCol className="waiting-text">
                <IonRow className="ion-justify-content-end">
                    <IonImg
                        onClick={() => onDidDismiss()}
                        src={`${baseUrl()}/images/assets/dismiss_button.svg`}
                    />
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <h2><strong>Please note</strong></h2>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <span>We are currently experiencing longer than usual wait times</span>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <strong>The current estimated wait time is</strong>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <h2><strong>{waitingLabel} <span className="big-time-indicator">{waitingRange}</span> minutes</strong></h2>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <span>This is an estimate based on recent orders. Times may vary.</span>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <Button
                        onClick={onDidAccept}
                        expand='block'
                        rounded={true}
                        size='large'
                        style={{width:'200px'}}
                    >
                        OK
                    </Button>
                </IonRow>
            </IonCol>
        </IonRow>
    </IonModal>
}
